<template>
  <span class="i-layout-header-trigger i-layout-header-trigger-min i-layout-header-trigger-in">
    <Notification
      :wide="isMobile"
      :badge-props="badgeProps"
      class="i-layout-header-notice"
      :class="{ 'i-layout-header-notice-mobile': isMobile }"
      :count="title"
      @on-clear="handleClear"
      @on-load-more="handleLoadMore"
    >
      <Icon slot="icon" custom="i-icon i-icon-notification" @click="init()"/>
      <NotificationTab
        :title="$t('page.notice.notify')"
        name="message"
        :count="unreadMessage"
        :loaded-all="messageList.length >= count"
        :loading="messageLoading"
        :scroll-to-load="false"
      >
        <NotificationItem
          v-for="(item, index) in messageList"
          :key="index"
          :title="item.title"
          :icon="item.type"
          :icon-color="item.iconColor"
          :time="item.createTime"
          :read="item.read"
          @click.native="addtit1(item,index)"
        />
      </NotificationTab>
      <NotificationTab
        :title="$t('page.shortcut.todo')"
        name="todo"
        :count="unreadTodo"
        :loading="todoLoading"
        :loaded-all="todoList.length >= otherCount"
        :scroll-to-load="false"
      >
        <NotificationItem
          v-for="(item, index) in todoList"
          :key="index"
          :title="item.title"
          :time="item.createTime"
          :tag-props="item.tagProps"
          :read="item.read"
          @click.native="addtit2(item,index)"
        />
      </NotificationTab>
    </Notification>
    <Modal v-model="modal1"  scrollable :title="$t('page.notice.notifyInfo')" @on-ok="ok1" :closable="false" :mask-closable="false">
      <div v-html="content"></div>
      <Button slot="footer" @click="ok1" type="primary">{{$t('page.common.ok')}}</Button>
    </Modal>
    <Modal v-model="modal2"  scrollable  :title="$t('page.notice.todoInfo')"  @on-ok="ok2" :closable="false" :mask-closable="false">
      <div v-html="content"></div>
      <Button slot="footer" @click="ok2" type="primary">{{$t('page.common.ok')}}</Button>
    </Modal>
  </span>
</template>
<script>
//:tag="item.type"   待办的状态   @click="openmodal"

import { mapState } from "vuex";

export default {
  props: ["title"],
  name: "iHeaderNotice",
  data() {
    return {
      badgeProps: {
        offset: [20, 0]
      },
      count:0,
      otherCount:0,
      number:1,
      modal1: false,
      modal2:false,
      content: "",
      id: "",
      messageList: [],
      todoList: [],
      messageBaseList:[],
      todoBaseList:[],
      messageLoading: false,
      followLoading: false,
      todoLoading: false,
      unreadMessage:0,
      unreadTodo:0
    };
  },
  computed: {
    ...mapState("admin/layout", ["isMobile"]),
    // unreadMessage() {
    //   let unread = 0;
    //   this.messageList.forEach(item => {
    //     if (item.status == "1") unread++;
    //   });
    //   return unread;
    // },

    // unreadTodo() {
    //   let unread = 0;
    //   this.todoList.forEach(item => {
    //     if (item.status == "1") unread++;
    //   });
    //   return unread;
    // },
  },
  created () {

  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      //初始加载待办 通知消息
      this.abHttpUtil
        .get("/oa/oAInstationMsg/getInstationMsg?type=2&pageNo=1&pageSize=5")
        .then(res => {
        	if(!res.data)return ;
          this.messageBaseList = res.data.resultList;
          this.messageList = this.messageBaseList;
          this.count = res.data.count;
          this.unreadMessage  = res.data.count;
          console.log(res)
          for (var i = 0; i < this.messageList.length; i++) {
            if (this.messageList[i].type == "21") {
              this.$set(this.messageList[i], `type`, "md-star");
              this.$set(this.messageList[i], "iconColor", "#ff9900");
            }
            if (this.messageList[i].type == "22") {
              this.$set(this.messageList[i], `type`, "md-home");
              this.$set(this.messageList[i], "iconColor", "#87d068");
            }
            if (this.messageList[i].type == "23") {
              this.$set(this.messageList[i], `type`, "md-plane");
              this.$set(this.messageList[i], "iconColor", "#3391e5");
            }
          }
        })
      this.abHttpUtil
        .get("/oa/oAInstationMsg/getInstationMsg?type=1&pageNo=1&pageSize=5")
        .then(res => {
        	if(!res.data)return ;
          this.todoBaseList = res.data.resultList;
          this.todoList =this.todoBaseList;
          this.otherCount = res.data.count
          this.unreadTodo = res.data.count
        });
    },
    addtit1(item, id) {
      console.log(item)
      this.modal1 = true;
      this.id = item.id;
      this.abHttpUtil.get(`/oa/oAInstationMsg/get?id=${this.id}`)
      .then(res => {
        this.content = res.data.content;
      })
    },
    addtit2(item, id) {
      console.log(item)
      this.modal2 = true;
      this.id = item.id;
      this.abHttpUtil.get(`/oa/oAInstationMsg/get?id=${this.id}`)
      .then(res => {
        this.content = res.data.content;
      })
    },
    ok1() {
      this.modal1 = false;
      this.abHttpUtil
        .post("oa/oAInstationMsg/save", {
          id: this.id,
          status: "2"
        })
        .then(res => {
            this.$Message.success($t('page.notice.messageRead'));
          this.init ();
          this.abHttpUtil
            .get("/oa/oAInstationMsg/getInstationMsg?type=2&pageNo=1&pageSize=5")
            .then(res => {
              this.$emit("increase", res.data.totalCount);
              this.unreadMessage = res.data.count;
            });
        });
    },
    ok2() {
      this.modal2 = false;
      this.abHttpUtil
        .post("oa/oAInstationMsg/save", {
          id: this.id,
          status: "2"
        })
        .then(res => {
            this.$Message.success($t('page.notice.messageRead'));
          this.init ();
          this.abHttpUtil
            .get("/oa/oAInstationMsg/getInstationMsg?type=1&pageNo=1&pageSize=5")
            .then(res => {
              this.$emit("increase", res.data.totalCount);
              this.unreadTodo = res.data.count;
            });
        });
    },
    handleLoadMore(tab) {

      this.loadMore(tab.name);
    },
    loadMore(type) {
      if (this[`${type}Loading`]) return;
      this[`${type}Loading`] = true;
      if(type == 'message') {
        this.number += 1;

        this.abHttpUtil
        .get(`/oa/oAInstationMsg/getInstationMsg?type=2&pageNo=${this.number}&pageSize=5`)
        .then(res => {

          this.messageList = res.data.resultList;
          for (var i = 0; i < this.messageList.length; i++) {
            if (this.messageList[i].type == "21") {
              this.$set(this.messageList[i], `type`, "md-star");
              this.$set(this.messageList[i], "iconColor", "#ff9900");
            }
            if (this.messageList[i].type == "22") {
              this.$set(this.messageList[i], `type`, "md-home");
              this.$set(this.messageList[i], "iconColor", "#87d068");
            }
            if (this.messageList[i].type == "23") {
              this.$set(this.messageList[i], `type`, "md-plane");
              this.$set(this.messageList[i], "iconColor", "#3391e5");
            }
          }
          this[`${type}Loading`] = false;
        })
      } else {
        this.number += 1;
        this.abHttpUtil
        .get(`/oa/oAInstationMsg/getInstationMsg?type=1&pageNo=${this.number}&pageSize=5`)
        .then(res => {
          this.todoList = res.data.resultList;
          console.log(this.todoList)
          this[`${type}Loading`] = false;
        })
      }
    },
    handleClear(tab) {
      this.clearUnread(tab.name);
    },
    clearUnread(type) {
      //改变状态
      // item.status = 2;

      var length = this[`${type}List`].length;
      console.log(this[`${type}List`])
      var arr = [];
      for (var i = 0; i < length; i++) {
        arr[i] = this[`${type}List`][i].id;
        this[`${type}List`][i].status == 2;
      }
      var str = arr.toString();
      //调用删除的接口 批量阅读删除
      this.abHttpUtil.post(`oa/oAInstationMsg/remove?id=${str}`).then(res => {
          this.$Message.success($t('page.notice.markReadedSuccess'));
        this[`${type}List`] = this[`${type}List`].map(item => {
                    item.status = 2;
                    return item;
                });
        this.init()
        if (type == 'message') {
          this.abHttpUtil
          .get("/oa/oAInstationMsg/getInstationMsg?type=2&pageNo=1&pageSize=5")
          .then(res => {
            this.$emit("increase", res.data.totalCount);
          });
        } else {
          this.abHttpUtil
          .get("/oa/oAInstationMsg/getInstationMsg?type=1&pageNo=1&pageSize=5")
          .then(res => {
            this.$emit("increase", res.data.totalCount);
          });
        }

      });
    }
  }
};
</script>
